import { ArrowBack, AssignmentLate, PersonAdd } from '@mui/icons-material';
import { useCallback, useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams, useMatch, Navigate } from 'react-router-dom';
import NavItem from '../../components/Sidebar/NavItem';
import Sidenav from '../../components/Sidebar/Sidenav';
import { usePersonContext } from '../../contexts/PersonContext';
import { useFetch, usePersons } from '../../hooks';
import BasicData from './pages/BasicInfo';
import Profiles from './pages/Profiles';
import PersonPages from './pages/types';

const PersonRouter = (): JSX.Element => {
  const { pathnameBase } = useMatch({ path: '/persons/:id/*' })!;

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`${pathnameBase}/basic-info`} replace />} />

      <Route path="/basic-info" element={<BasicData />} />

      <Route path="/profiles" element={<Profiles />} />
    </Routes>
  );
};

export const Person = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const { handleUnselectPerson, setPerson, setLoading } = usePersonContext();
  const repository = usePersons();
  const { data, loading, refetch } = useFetch((selectedId?: string) => repository.fetchById((selectedId ?? id)!), {
    ignoreFirstCall: true,
  });
  const [activePage, setActivePage] = useState<PersonPages>();
  const history = useNavigate();
  const match = useMatch({ path: '/persons/:id/*' });

  const handlePageChange = useCallback(
    (page: PersonPages) => {
      setActivePage(page);
      history(page);
    },
    [history]
  );

  const getActivePage = useCallback((page: PersonPages) => page === activePage, [activePage]);

  useEffect(() => {
    if (match) {
      const { pathnameBase, pathname: _path } = match;
      const initialRoute = _path.replace(pathnameBase, '').replace('/', '');
      setActivePage(initialRoute as PersonPages);
    }
  }, [match]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    setPerson(data ?? null);
  }, [data, setPerson]);

  useEffect(() => {
    if (id !== 'new') {
      refetch(id);
    }
  }, [id, refetch]);

  return (
    <>
      <Sidenav>
        <>
          <NavItem title="voltar" icon={<ArrowBack />} onClick={() => handleUnselectPerson()} />
          <NavItem
            title="dados básicos"
            icon={<AssignmentLate />}
            active={getActivePage(PersonPages.BasicInfo)}
            onClick={() => handlePageChange(PersonPages.BasicInfo)}
          />
          {id !== 'new' && (
            <NavItem
              title="perfis"
              icon={<PersonAdd />}
              active={getActivePage(PersonPages.Profiles)}
              onClick={() => handlePageChange(PersonPages.Profiles)}
            />
          )}
        </>
      </Sidenav>
      <PersonRouter />
    </>
  );
};

export default Person;
